export const savedAddress = {
	savedAddress: {
		company: 'Company',
		name: 'Name',
		address: 'Address',
		phone: 'Phone',
		editAddress: 'Edit Address',
		deleteAddress: 'Delete Address',
		deleteAddressConfirmationMessage: 'Do you want to delete the address?',
		addAddress: 'Add Address',
	}
};